<template>
	<div class="order">
		<div class="btnbox">
			<el-button type="primary" size="small" @click="onsyncorder()">下载拼多多订单</el-button>
			<el-button type="primary" size="small" @click="onptxd()">向平台下单</el-button>
			<el-button type="primary" size="small" @click="onSyncToShop()">同步到店铺</el-button>
		</div>
		<div class="tablebox">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" label-width="0"
					v-if="filtershow">
					<el-form-item label="">
						<el-select v-model="formfilter.shop_id" placeholder="店铺">
							<el-option label="全部" value=""></el-option>
							<el-option :label="v.mall_name || v.shop_name" :value="v.id" v-for="(v,k) in shop_list" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.order_sn" placeholder="订单号"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="formfilter.order_status" placeholder="订单状态">
							<el-option label="订单状态" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.pdd_order_status"
								:key="k"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="formfilter.refund_status" placeholder="无售后或售后关闭">
							<el-option label="全部" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.pdd_refund_status"
								:key="k"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="formfilter.match_status" placeholder="售后状态">
							<el-option label="下单情况" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.pdd_match_status"
								:key="k"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="formfilter.platform_order_status" placeholder="平台订单状态">
							<el-option label="平台订单状态" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.order_status"
								:key="k"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="formfilter.match_security" placeholder="撕防伪">
							<el-option label="撕防伪" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.discount_security"
								:key="k"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="zk" @click="filtershow=!filtershow ">
				<span>{{filtershow ? '收起':'展开'}}</span>
			</div>
			<div class="tablediv" ref="tablediv">
				<el-table
					ref="orderTable"
					:data="list"
					style="width: 100%"
					border
					:height="tableHeight"
					@selection-change="handleSelectionChange"
					@header-dragend="layoutOrderTable"
				>
					<el-table-column type="selection" width="40" align="center" header-align="center" fixed="left" />
					<el-table-column prop="mall_name" label="店铺名称" align="center" header-align="center" min-width="100px">
					</el-table-column>
					<el-table-column prop="pay_time" label="支付时间" align="center" header-align="center" min-width="100px">
					</el-table-column>
					<el-table-column
						:key="'order-sn-pretime-' + orderSnPreTimeColumnWidth"
						label="订单号/预发日期"
						align="center"
						header-align="center"
						:min-width="orderSnPreTimeColumnWidth"
						:width="orderSnPreTimeColumnWidth"
						class-name="order-sn-pretime-column"
					>
						<template slot-scope="scope">
							<div class="order-sn-pretime-cell">
								<div class="order-sn-line">{{ scope.row.order_sn || '-' }}</div>
								<div class="pretime-line">{{ scope.row.match_pre_time_str || '-' }}</div>
								<div v-if="scope.row.is_auto_cancel == 1" class="auto-cancel-tip">（系统）</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						:key="'goods-security-' + goodsSecurityColumnWidth"
						label="商品(数量|渠道价)/防伪"
						align="center"
						header-align="center"
						:min-width="goodsSecurityColumnWidth"
						:width="goodsSecurityColumnWidth"
						class-name="goods-security-column"
					>
						<template slot-scope="scope">
							<div class="goods-security-cell">
								<div class="goods-line">{{ scope.row.good || '-' }}</div>
								<div class="security-line">{{ scope.row.match_security_str || '-' }}</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						:key="'channel-trade-' + channelTradeNoColumnWidth"
						label="渠道/订单号"
						align="center"
						header-align="center"
						:min-width="channelTradeNoColumnWidth"
						:width="channelTradeNoColumnWidth"
						class-name="channel-trade-column"
					>
						<template slot-scope="scope">
							<div class="channel-trade-cell">
								<div class="channel-line">
									<span>{{ scope.row.shop_name || '-' }}</span>
									<el-tag v-if="scope.row.is_mandatory" size="mini" type="danger" effect="plain" style="margin-left: 4px;">必</el-tag>
								</div>
								<div class="trade-no-line">{{ scope.row.trade_no || '-' }}</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="delivery_name" label="快递公司" align="center" header-align="center"
						min-width="110px">
					</el-table-column>
					<el-table-column prop="return_address" label="渠道退货地址" align="center" header-align="center"
						min-width="200px" class-name="return-address-column">
						<template slot-scope="scope">
							<el-popover
								v-if="scope.row.return_address"
								trigger="hover"
								placement="top"
								width="360"
								popper-class="return-address-popover"
							>
								<div class="return-address-popover__content">{{ scope.row.return_address }}</div>
								<el-button type="text" size="mini" @click="oncopy(scope.row.return_address)">复制</el-button>
								<div slot="reference" class="return-address-cell">{{ scope.row.return_address }}</div>
							</el-popover>
							<span v-else class="return-address-empty">-</span>
						</template>
					</el-table-column>
					<el-table-column label="下单情况" align="center" header-align="center"
						min-width="120px" class-name="match-status-column">
						<template slot-scope="scope">
							<div class="match-status-cell">
								<span
									v-if="formatMatchStatusText(scope.row)"
									class="match-status-tag"
									:class="'match-status-tag--' + matchStatusTagType(scope.row)"
								>{{ formatMatchStatusText(scope.row) }}</span>
								<span v-else class="match-status-empty">-</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="platform_order_status" label="平台订单状态" align="center" header-align="center"
						min-width="110px" class-name="match-status-column">
						<template slot-scope="scope">
							<div class="match-status-cell">
								<span
									v-if="formatPlatformOrderStatus(scope.row)"
									class="match-status-tag"
									:class="'match-status-tag--' + platformOrderStatusTagType(scope.row)"
								>{{ formatPlatformOrderStatus(scope.row) }}</span>
								<span v-else class="match-status-empty">-</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="此单盈利" align="center" header-align="center" min-width="120px">
						<template slot-scope="scope">
							<span>{{scope.row.profit}}</span>/<span>{{scope.row.free_return_rate}}</span>+<span>{{scope.row.exceed_rate_deduct}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="remark" label="备注" align="center" header-align="center" min-width="160px">
					</el-table-column>
					<el-table-column label="订单金额(拼多多|平台)" align="center" header-align="center" min-width="170px">
						<template slot-scope="scope">
							<span>{{scope.row.goods_amount}}</span>/<span>{{scope.row.platform_amount}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="receiver_name" label="收件人姓名" align="center" header-align="center"
						min-width="120px">
					</el-table-column>
					<el-table-column prop="receiver_phone" label="收件人电话" align="center" header-align="center"
						min-width="120px">
					</el-table-column>
					<el-table-column label="收件人行政区" align="center" header-align="center" min-width="180px">
						<template slot-scope="scope">
							<span>{{scope.row.province}}</span>/<span>{{scope.row.city}}</span>/<span>{{scope.row.town}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="order_status_str" label="订单状态" align="center" header-align="center"
						min-width="120px">
					</el-table-column>
					<el-table-column
						prop="refund_status_str"
						label="售后状态"
						align="center"
						header-align="center"
						width="72"
						min-width="72"
						label-class-name="refund-status-column"
						class-name="refund-status-column"
						:fixed="refundStatusFixed ? 'right' : false"
					>
						<template slot-scope="scope">
							<div class="status-text-4">{{ scope.row.refund_status_str }}</div>
						</template>
					</el-table-column>
					<el-table-column prop="group_status_str" label="成团状态" align="center" header-align="center"
						min-width="80px">
					</el-table-column>
					<el-table-column prop="risk_control_status_str" label="审核状态" align="center" header-align="center"
						min-width="80px">
					</el-table-column>
					<el-table-column label="线上物流单号/同步状态" align="center" header-align="center"
						min-width="190px" class-name="match-status-column">
						<template slot-scope="scope">
							<div class="tracking-sync-cell">
								<div class="tracking-sync-number">{{ scope.row.tracking_number || '-' }}</div>
								<div class="match-status-cell">
									<template v-if="isDeliverySyncFailed(scope.row)">
										<div class="delivery-sync-error-text">{{ formatDeliverySyncStatus(scope.row) }}</div>
										<div
											v-if="formatDeliverySyncTime(scope.row)"
											class="tracking-sync-time"
										>{{ formatDeliverySyncTime(scope.row) }}</div>
									</template>
									<span
										v-else-if="formatDeliverySyncStatus(scope.row)"
										class="match-status-tag"
										:class="'match-status-tag--' + deliverySyncStatusTagType(scope.row)"
									>{{ formatDeliverySyncStatus(scope.row) }}</span>
									<span v-else class="match-status-empty">-</span>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="match_delivery_price" label="平台快递金额" align="center" header-align="center"
						min-width="110px">
					</el-table-column>
					<el-table-column prop="buyer_memo" label="买家留言" align="center" header-align="center"
						min-width="180px">
					</el-table-column>
					<el-table-column prop="create_time_str" label="创建时间" align="center" header-align="center"
						min-width="100px">
					</el-table-column>
					<el-table-column prop="update_time_str" label="更新时间" align="center" header-align="center"
						min-width="100px">
					</el-table-column>
					<el-table-column label="操作" align="center" header-align="center" fixed="right" width="140px">
						<template slot-scope="scope">
							<div class="operation_i">
								<div>
									<span @click="onsave(scope.row)">匹配渠道</span>
								</div>
								<!-- <div>
									<span @click="onxgqd(scope.row)">修改渠道</span>
								</div> -->
								<div>
									<span @click="onxgkh(scope.row)">修改款号</span>
								</div>
								<div v-if="needFillReceiver(scope.row)">
									<span class="op-fill-receiver" @click="onFillReceiver(scope.row)">补全地址</span>
								</div>
								<div v-if="needMatchSource(scope.row)">
									<span class="op-match-source" @click="onMatchSource(scope.row)">匹配货源</span>
								</div>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="pagediv">
			<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
				:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
				@current-change="handleCurrentChange" @size-change="handleSizeChange">
			</el-pagination>
		</div>

		<el-dialog title="匹配渠道" :visible.sync="show1" width="90%" :before-close="onclose1"
			:close-on-click-modal="false">
			<div class="info">
				<div class="h4">订单信息</div>
				<div class="block">
					<div>订单号:<span>{{checkval.order_sn}}</span></div>
					<div>支付时间:<span>{{checkval.pay_time}}</span></div>
					<div>订单金额:<span>{{checkval.platform_amount}}</span></div>
				</div>
				<div class="block">
					<div>收件人信息:<span>{{checkval.receiver_name}}{{checkval.receiver_phone}}</span></div>
					<div>收件人地址:<span>{{checkval.receiver_address}}</span></div>
				</div>
				<div class="block">
					<div>买家留言:<span>{{checkval.buyer_memo}}</span></div>
				</div>
			</div>
			<div class="table">
				<div class="h4 table-title">
					<span>订单商品渠道信息</span>
					<span class="goods-order-meta">
						<span class="goods-meta-tag goods-meta-tag--style">
							<em>款号</em>
							<strong>{{ formatDisplayValue(checkval.style_number) }}</strong>
						</span>
						<span class="goods-meta-tag goods-meta-tag--size">
							<em>尺码</em>
							<strong>{{ formatDisplayValue(checkval.size) }}</strong>
						</span>
						<span class="goods-meta-tag goods-meta-tag--qty">
							<em>数量</em>
							<strong>{{ formatOrderQuantity(checkval) }}</strong>
						</span>
					</span>
				</div>
				<el-table :data="checklist" style="width: 100%" border height="100%" @current-change="handleSelectChange">
					<el-table-column label="" width="46" align="center" fixed="left">
						<template slot-scope="scope">
							<el-radio v-model="tableRadio" :label="scope.row" class="myradio"><span></span></el-radio>
						</template>
					</el-table-column>
					<el-table-column prop="shop_name" label="渠道" align="center" header-align="center" min-width="70px"
						fixed="left">
					</el-table-column>
					<el-table-column prop="match_stock" label="库存" align="center" header-align="center" min-width="70px">
					</el-table-column>
					<el-table-column
						v-for="col in deliveryColumns"
						:key="'delivery-' + col.delivery_id"
						:label="col.delivery_name"
						align="center"
						header-align="center"
						min-width="100px"
						class-name="delivery-price-column"
					>
						<template slot-scope="scope">
							<span
								v-if="getDeliveryOption(scope.row, col.delivery_id)"
								class="delivery-price-cell"
								:class="{ 'delivery-price-cell--active': isDeliverySelected(scope.row, col.delivery_id) }"
								@click.stop="onSelectDelivery(scope.row, col.delivery_id)"
							>{{ getDeliveryOption(scope.row, col.delivery_id).delivery_price }}</span>
							<span v-else class="delivery-price-empty">-</span>
						</template>
					</el-table-column>
					<el-table-column prop="product_price" label="吊牌价" align="center" header-align="center"
						min-width="70px">
					</el-table-column>
					<el-table-column prop="true_discount" label="折扣" align="center" header-align="center"
						min-width="70px">
					</el-table-column>
					<el-table-column prop="stop_take_time" label="截单" align="center" header-align="center"
						min-width="70px">
					</el-table-column>
					<el-table-column prop="agent_price" label="代理价(单价)" align="center" header-align="center"
						min-width="70px">
					</el-table-column>
					<el-table-column prop="prev_send_delivery_date" label="预发" align="center" header-align="center"
						min-width="100px">
					</el-table-column>
					<el-table-column prop="free_return_rate" label="退货比" align="center" header-align="center"
						min-width="70px">
					</el-table-column>
					<el-table-column prop="exceed_rate_deduct" label="扣款" align="center" header-align="center"
						min-width="70px">
					</el-table-column>
					<el-table-column prop="allocation_rate" label="配货率" align="center" header-align="center"
						min-width="70px">
					</el-table-column>
					<el-table-column prop="on_time_rate" label="准时率" align="center" header-align="center"
						min-width="70px">
					</el-table-column>
					<el-table-column prop="security" label="撕防伪" align="center" header-align="center" min-width="80px">
						<template slot-scope="scope">
							<div>{{onsecurity(scope.row.security)}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="agent_price" label="综合价格" align="center" header-align="center"
						min-width="70px">
					</el-table-column>
				</el-table>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose1">取消</el-button>
				<el-button type="primary" @click="onsubxg()">确定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="修改款号" :visible.sync="show3" width="650px" :before-close="onclose3">
			<div class="forms" v-if="show3">
				<el-form ref="ruleForm1" :model="ruleForm1" :rules="styleNumberRules" label-width="140px">
					<el-form-item label="拼多多订单编号" prop="order_sn" class="item">
						<el-input v-model="ruleForm1.order_sn" readonly />
					</el-form-item>
					<el-form-item label="商品code|size" prop="style_number_size" class="item">
						<el-input v-model="ruleForm1.style_number_size" placeholder="请输入商品code|size" />
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="onsubkh">保存</el-button>
				<el-button @click="onclose3">关闭</el-button>
			</div>
		</el-dialog>

		<el-dialog title="订单下载" :visible.sync="show4" width="650px" :before-close="onclose4">
			<div class="forms" v-if="show4">
				<el-form ref="ruleForm2" :model="ruleForm2" :rules="rules" label-width="80px">
					<el-form-item label="店铺" prop="shop_id" class="item">
						<el-select v-model="ruleForm2.shop_id" placeholder="请选择店铺">
							<el-option :label="v.mall_name || v.shop_name" :value="v.id" v-for="(v,k) in shop_list" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="开始日期" class="item">
						<el-date-picker
							v-model="ruleForm2.btime"
							type="date"
							placeholder="默认昨天"
							value-format="yyyy-MM-dd"
							clearable
						/>
					</el-form-item>
					<el-form-item label="结束日期" class="item">
						<el-date-picker
							v-model="ruleForm2.etime"
							type="date"
							placeholder="默认今天"
							value-format="yyyy-MM-dd"
							clearable
						/>
					</el-form-item>
				</el-form>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose4">取消</el-button>
				<el-button type="primary" @click="onsubxz()">确定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="手动补填收件人信息" :visible.sync="showFillReceiver" width="650px"
			:before-close="onCloseFillReceiver" :close-on-click-modal="false">
			<div class="forms" v-if="showFillReceiver">
				<el-form ref="fillReceiverForm" :model="fillReceiverForm" :rules="fillReceiverRules" label-width="100px">
					<el-form-item label="订单号" class="item">
						<el-input v-model="fillReceiverForm.order_sn" readonly />
					</el-form-item>
					<el-form-item label="收件人" prop="receiver_name" class="item">
						<el-input v-model="fillReceiverForm.receiver_name" placeholder="请输入收件人姓名" />
					</el-form-item>
					<el-form-item label="电话" prop="receiver_phone" class="item">
						<el-input v-model="fillReceiverForm.receiver_phone" placeholder="请输入收件人电话" />
					</el-form-item>
					<el-form-item label="省市区" class="item">
						<el-cascader
							v-model="fillReceiverForm.areaData"
							:props="areaProps"
							:options="regionData"
							clearable
							filterable
							placeholder="请选择省 / 市 / 区（可选）"
							class="fill-receiver-cascader"
						/>
					</el-form-item>
					<el-form-item label="详细地址" prop="receiver_address" class="item">
						<el-input
							v-model="fillReceiverForm.receiver_address"
							type="textarea"
							:rows="2"
							placeholder="街道、门牌号等详细地址"
						/>
					</el-form-item>
				</el-form>
				<div class="fill-receiver-tip">请前往拼多多商家后台查看该订单的收件人信息</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onCloseFillReceiver" :disabled="fillReceiverSubmitting">取消</el-button>
				<el-button type="primary" :loading="fillReceiverSubmitting" @click="onSubmitFillReceiver">确认保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { regionData } from 'element-china-area-data'

	export default {
		name: 'pddorder',
		data() {
			return {
				list: [],
				page: 1,
				pageSize: 100,
				total: 0,
				filtershow: true,
				show1: false,
				show2: false,
				show3: false,
				show4: false,
				showFillReceiver: false,
				fillReceiverSubmitting: false,
				matchSourceSubmitting: false,
				tableHeight: 480,
				tableScrollTimer: null,
				refundStatusFixed: false,
				operationColumnWidth: 140,
				regionData: [],
				areaProps: {
					value: 'label',
					label: 'label',
					children: 'children',
				},
				fillReceiverForm: {
					pdd_order_id: '',
					order_sn: '',
					receiver_name: '',
					receiver_phone: '',
					receiver_address: '',
					areaData: [],
				},
				fillReceiverRules: {
					receiver_name: [{
						required: true,
						message: '请输入收件人姓名',
						trigger: 'blur'
					}],
					receiver_phone: [{
						required: true,
						message: '请输入收件人电话',
						trigger: 'blur'
					}],
					receiver_address: [{
						required: true,
						message: '请输入收件人地址',
						trigger: 'blur'
					}]
				},
				formfilter: {
					shop_id: "",
					order_sn: "",
					order_status: "",
					refund_status: 1,
					match_status: "",
					platform_order_status: "",
					match_security: ""
				},
				alldata: [],
				shop_list: [],
				shop_id: "",
				checkval: {},
				checklist: [],
				ruleForm: {
					order_sn: "",
					shop_id: "",
					delivery_id: "",
					prev_send_delivery_time: "",
					agent_price: "",
					security: "",
					delivery_price: ""
				},

				tableRadio: null,
				deliveryColumns: [],
				ruleForm1: {
					order_sn: "",
					style_number_size: ""
				},

				styleNumberRules: {
					order_sn: [{
						required: true,
						message: '订单编号不能为空',
						trigger: 'blur'
					}],
					style_number_size: [{
						required: true,
						message: '请输入商品code|size',
						trigger: 'blur'
					}],
				},

				ruleForm2: {
					shop_id: "",
					btime: "",
					etime: "",
				},

				rules: {
					shop_id: [{
						required: true,
						message: '请选择店铺',
						trigger: 'change'
					}],

					delivery_id: [{
						required: true,
						message: '请选择快递',
						trigger: 'change'
					}],
					prev_send_delivery_time: [{
						required: true,
						message: '请选择店铺',
						trigger: 'change'
					}],
					shop_id: [{
						required: true,
						message: '请选择店铺',
						trigger: 'change'
					}],
					shop_id: [{
						required: true,
						message: '请选择店铺',
						trigger: 'change'
					}],
					shop_id: [{
						required: true,
						message: '请选择店铺',
						trigger: 'change'
					}],

					style_number_size: [{
						required: true,
						message: '请输入款号',
						trigger: 'blur'
					}],
				},
				orderStatusInitialized: false,
				refundStatusInitialized: false,
			}
		},

		inject: ['appdata', 'oncopy'],

		computed: {
			orderSnPreTimeColumnWidth() {
				return this.calcAdaptiveColumnWidth(function(row) {
					return [
						row && row.order_sn != null ? String(row.order_sn) : '',
						row && row.match_pre_time_str != null ? String(row.match_pre_time_str) : ''
					]
				}, '订单号/预发日期', 110, 320, 28)
			},
			goodsSecurityColumnWidth() {
				return this.calcAdaptiveColumnWidth(function(row) {
					return [
						row && row.good != null ? String(row.good) : '',
						row && row.match_security_str != null ? String(row.match_security_str) : ''
					]
				}, '商品(数量|渠道价)/防伪', 160, 480, 28)
			},
			channelTradeNoColumnWidth() {
				return this.calcAdaptiveColumnWidth(function(row) {
					var shopName = row && row.shop_name != null ? String(row.shop_name) : ''
					var tradeNo = row && row.trade_no != null ? String(row.trade_no) : ''
					var tagExtra = row && row.is_mandatory ? 28 : 0
					return [
						{ text: shopName, extra: tagExtra },
						tradeNo
					]
				}, '渠道/订单号', 110, 320, 28)
			}
		},

		watch: {
			filtershow() {
				this.$nextTick(function() {
					this.calcTableHeight()
				}.bind(this))
			},
			'appdata.list.pdd_order_status'(list) {
				if (!list || !list.length || this.orderStatusInitialized) {
					return
				}
				if (this.applyDefaultOrderStatus()) {
					this.onlist()
					return
				}
				this.orderStatusInitialized = true
				this.onlist()
			},
			'appdata.list.pdd_refund_status'(list) {
				if (!list || !list.length || this.refundStatusInitialized) {
					return
				}
				if (this.applyDefaultRefundStatus()) {
					this.onlist()
					return
				}
				this.refundStatusInitialized = true
				this.onlist()
			},
		},

		mounted() {
			this.regionData = regionData
			this.onshop()
			var appliedOrder = this.applyDefaultOrderStatus()
			var appliedRefund = this.applyDefaultRefundStatus()
			if (appliedOrder || appliedRefund) {
				this.onlist()
			} else if (this.appdata.list.pdd_order_status && this.appdata.list.pdd_order_status.length) {
				this.onlist()
			}
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect;
					var num = Number(cr.height) + 30;
					this.$refs.tablediv.style.height = "calc(100% - " + num + "px)";
					this.calcTableHeight();
				}
			});
			this.resizeObserver.observe(this.$refs.filter);
			this.$nextTick(function() {
				this.calcTableHeight();
				this.bindOrderTableScroll();
			}.bind(this));
		},

		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect();
			}
			this.unbindOrderTableScroll();
			if (this.tableScrollTimer) {
				clearTimeout(this.tableScrollTimer);
				this.tableScrollTimer = null;
			}
		},

		methods: {
			measureTextWidth(text) {
				var w = 0
				var s = text != null ? String(text) : ''
				for (var j = 0; j < s.length; j++) {
					w += s.charCodeAt(j) > 255 ? 14 : 8.2
				}
				return w
			},
			calcAdaptiveColumnWidth(getRowContent, headerText, minW, maxW, padding) {
				var pad = padding != null ? padding : 28
				var headerW = this.measureTextWidth(headerText) + pad
				var maxContentW = 0
				var list = this.list || []
				for (var i = 0; i < list.length; i++) {
					var content = getRowContent(list[i])
					var items = []
					if (Object.prototype.toString.call(content) === '[object Array]') {
						items = content
					} else {
						items = [content]
					}
					for (var t = 0; t < items.length; t++) {
						var item = items[t]
						var text = ''
						var extra = 0
						if (item && typeof item === 'object') {
							text = item.text != null ? String(item.text) : ''
							extra = item.extra || 0
						} else {
							text = item != null ? String(item) : ''
						}
						if (!text && !extra) {
							continue
						}
						var w = this.measureTextWidth(text) + extra
						if (w > maxContentW) {
							maxContentW = w
						}
					}
				}
				var width = Math.ceil(Math.max(headerW, maxContentW + pad))
				if (width < minW) {
					return minW
				}
				if (width > maxW) {
					return maxW
				}
				return width
			},
			calcTableHeight() {
				this.$nextTick(function() {
					var el = this.$refs.tablediv
					if (!el) {
						return
					}
					var h = el.clientHeight
					if (h > 200) {
						this.tableHeight = Math.floor(h)
					}
					this.layoutOrderTable()
					this.$nextTick(function() {
						this.updateRefundStatusFixed()
					}.bind(this))
				}.bind(this))
			},
			layoutOrderTable() {
				this.$nextTick(function() {
					var table = this.$refs.orderTable
					if (table && typeof table.doLayout === 'function') {
						table.doLayout()
					}
				}.bind(this))
			},
			getRefundStatusColumnMetrics() {
				var table = this.$refs.orderTable
				if (!table || !table.$el) {
					return null
				}
				var headerTable = table.$el.querySelector('.el-table__header-wrapper > table')
				if (!headerTable) {
					return null
				}
				var target = headerTable.querySelector('thead tr th.refund-status-column')
				if (!target) {
					return null
				}
				return {
					left: target.offsetLeft,
					width: target.offsetWidth || 110,
				}
			},
			updateRefundStatusFixed() {
				var table = this.$refs.orderTable
				if (!table || !table.$el) {
					return
				}
				var bodyWrapper = table.$el.querySelector('.el-table__body-wrapper')
				if (!bodyWrapper) {
					return
				}
				var hasOverflow = bodyWrapper.scrollWidth > bodyWrapper.clientWidth + 1
				if (!hasOverflow) {
					if (this.refundStatusFixed) {
						this.refundStatusFixed = false
						this.layoutOrderTable()
					}
					return
				}
				var metrics = this.getRefundStatusColumnMetrics()
				if (!metrics) {
					return
				}
				var scrollLeft = bodyWrapper.scrollLeft
				var visibleRight = scrollLeft + bodyWrapper.clientWidth - this.operationColumnWidth
				var shouldFix = metrics.left + metrics.width > visibleRight + 1
				if (shouldFix === this.refundStatusFixed) {
					return
				}
				this.refundStatusFixed = shouldFix
				this.layoutOrderTable()
				this.$nextTick(function() {
					this.updateRefundStatusFixed()
				}.bind(this))
			},
			bindOrderTableScroll() {
				var table = this.$refs.orderTable
				if (!table || !table.$el) {
					return
				}
				var bodyWrapper = table.$el.querySelector('.el-table__body-wrapper')
				if (!bodyWrapper || bodyWrapper._orderScrollBound) {
					return
				}
				bodyWrapper._orderScrollBound = true
				this._orderTableBodyWrapper = bodyWrapper
				bodyWrapper.addEventListener('scroll', this.onOrderTableScroll, { passive: true })
			},
			unbindOrderTableScroll() {
				if (this._orderTableBodyWrapper) {
					this._orderTableBodyWrapper.removeEventListener('scroll', this.onOrderTableScroll)
					this._orderTableBodyWrapper._orderScrollBound = false
					this._orderTableBodyWrapper = null
				}
			},
			onOrderTableScroll() {
				if (this.tableScrollTimer) {
					clearTimeout(this.tableScrollTimer)
				}
				this.tableScrollTimer = setTimeout(function() {
					this.tableScrollTimer = null
					this.updateRefundStatusFixed()
				}.bind(this), 16)
			},
			resolveDefaultOrderStatus() {
				var list = this.appdata && this.appdata.list && this.appdata.list.pdd_order_status
				if (!list || !list.length) {
					return ''
				}
				for (var i = 0; i < list.length; i++) {
					if (list[i].name === '待发货') {
						return list[i].id
					}
				}
				return ''
			},
			applyDefaultOrderStatus() {
				var defaultStatus = this.resolveDefaultOrderStatus()
				if (defaultStatus === '' || defaultStatus == null) {
					return false
				}
				this.formfilter.order_status = defaultStatus
				this.orderStatusInitialized = true
				return true
			},
			resolveDefaultRefundStatus() {
				var list = this.appdata && this.appdata.list && this.appdata.list.pdd_refund_status
				if (list && list.length) {
					for (var i = 0; i < list.length; i++) {
						if (list[i].name === '无售后或售后关闭') {
							return list[i].id
						}
					}
					for (var j = 0; j < list.length; j++) {
						if (list[j].id == 1) {
							return list[j].id
						}
					}
				}
				return 1
			},
			applyDefaultRefundStatus() {
				var defaultStatus = this.resolveDefaultRefundStatus()
				if (defaultStatus === '' || defaultStatus == null) {
					return false
				}
				this.$set(this.formfilter, 'refund_status', defaultStatus)
				this.refundStatusInitialized = true
				return true
			},
			onfilter() {
				this.page = 1;
				this.onlist();
			},

			onreset() {
				this.formfilter = {
					shop_id: "",
					order_sn: "",
					order_status: this.resolveDefaultOrderStatus(),
					refund_status: this.resolveDefaultRefundStatus(),
					match_status: "",
					platform_order_status: "",
					match_security: ""
				};
				this.page = 1;
				this.onlist();
			},

			handleCurrentChange() {
				this.onlist();
			},

			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.onlist();
			},

			onshop() {
				var obj = {
					page: 1,
					limit: 99999
				};

				this.$axios.post('api/retail_shop/list', obj).then(res => {
					if (res.data.code == 0) {
						this.shop_list = res.data.data.list;
						// if(this.shop_list.length > 0) {
						// 	this.formfilter.shop_id = this.shop_list[0].id;
						// 	this.checkid = this.shop_list[0].id;
						// 	this.onlist();
						// }
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onlist() {
				var obj = JSON.parse(JSON.stringify(this.formfilter));
				obj.page = this.page;
				obj.limit = this.pageSize;

				return this.$axios.post('api/order/out_list', obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.list = res.data.data.list;
						this.calcTableHeight();
					} else {
						this.$message.error(res.data.message);
					}
					return res
				}).catch(err => {
					console.log(err)
					throw err
				})
			},

			handleSelectionChange(val) {
				this.alldata = val;
			},

			onsyncorder() {
				if (this.shop_list.length > 0) {
					this.ruleForm2.shop_id = this.shop_list[0].id
				}
				this.show4 = true
			},

			onclose4() {
				this.show4 = false
				this.ruleForm2 = {
					shop_id: "",
					btime: "",
					etime: "",
				}
			},

			onsave(val) {
				var obj = {
					order_sn: val.order_sn
					// order_sn: "260417-405673121342434"
				};
				this.checkval = val;
				this.$axios.post('api/order/out_get_match', obj).then(res => {
					if (res.data.code == 0) {
						this.checklist = res.data.data || [];
						this.restoreMatchSelection(this.checklist, val)
						this.deliveryColumns = this.buildDeliveryColumns(this.checklist)
						this.show1 = true;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			// 回显上次匹配：列表行 shop_name / delivery_name / match_delivery_price（及可能的 delivery_id）
			restoreMatchSelection(list, order) {
				var selectedRow = null
				var self = this
				;(list || []).forEach(function(row) {
					var configs = row && row.delivery_config ? row.delivery_config : []
					var firstDelivery = configs[0]
					var checked = firstDelivery ? firstDelivery.delivery_id : ''
					var matchedShop = self.isMatchedChannelRow(row, order)
					if (matchedShop) {
						var savedDelivery = self.findSavedDelivery(configs, order)
						if (savedDelivery) {
							checked = savedDelivery.delivery_id
						}
						selectedRow = row
					}
					self.$set(row, 'checked', checked)
					self.$set(row, 'order_sn', order && order.order_sn ? order.order_sn : '')
				})
				this.tableRadio = selectedRow
			},

			isMatchedChannelRow(row, order) {
				if (!row || !order) {
					return false
				}
				// 渠道 shop_id（若列表有独立匹配字段）
				var matchShopId = order.match_shop_id != null && order.match_shop_id !== ''
					? order.match_shop_id
					: (order.match_shopid != null && order.match_shopid !== '' ? order.match_shopid : null)
				if (matchShopId != null && row.shop_id == matchShopId) {
					return true
				}
				// 列表「渠道/订单号」展示的是已匹配渠道名
				if (order.shop_name && row.shop_name && String(order.shop_name) === String(row.shop_name)) {
					return true
				}
				return false
			},

			findSavedDelivery(configs, order) {
				if (!configs || !configs.length || !order) {
					return null
				}
				var savedId = order.delivery_id != null && order.delivery_id !== ''
					? order.delivery_id
					: order.match_delivery_id
				if (savedId != null && savedId !== '') {
					for (var i = 0; i < configs.length; i++) {
						if (configs[i].delivery_id == savedId) {
							return configs[i]
						}
					}
				}
				if (order.delivery_name) {
					for (var j = 0; j < configs.length; j++) {
						if (String(configs[j].delivery_name) === String(order.delivery_name)) {
							return configs[j]
						}
					}
				}
				if (order.match_delivery_price != null && order.match_delivery_price !== '') {
					for (var k = 0; k < configs.length; k++) {
						if (String(configs[k].delivery_price) === String(order.match_delivery_price)) {
							return configs[k]
						}
					}
				}
				return null
			},

			buildDeliveryColumns(list) {
				var columns = []
				var seen = {}
				;(list || []).forEach(function(row) {
					var configs = row && row.delivery_config ? row.delivery_config : []
					configs.forEach(function(item) {
						if (!item || item.delivery_id == null || item.delivery_id === '') {
							return
						}
						var key = String(item.delivery_id)
						if (seen[key]) {
							return
						}
						seen[key] = true
						columns.push({
							delivery_id: item.delivery_id,
							delivery_name: item.delivery_name || String(item.delivery_id)
						})
					})
				})
				return columns
			},

			getDeliveryOption(row, deliveryId) {
				if (!row || !row.delivery_config || !row.delivery_config.length) {
					return null
				}
				for (var i = 0; i < row.delivery_config.length; i++) {
					if (row.delivery_config[i].delivery_id == deliveryId) {
						return row.delivery_config[i]
					}
				}
				return null
			},

			isDeliverySelected(row, deliveryId) {
				return !!(this.tableRadio === row && row && row.checked == deliveryId)
			},

			onSelectDelivery(row, deliveryId) {
				if (!row || !this.getDeliveryOption(row, deliveryId)) {
					return
				}
				this.$set(row, 'checked', deliveryId)
				this.tableRadio = row
			},

			onclose1() {
				this.show1 = false;
				this.checkval = {};
				this.checklist = [];
				this.tableRadio = null;
				this.deliveryColumns = [];
			},

			onxgqd() {
				this.show2 = true;
			},

			onclose2() {
				this.show2 = false;
			},

			onxgkh(row) {
				this.ruleForm1.order_sn = row.order_sn || ''
				this.ruleForm1.style_number_size = this.formatStyleNumberSize(row)
				this.show3 = true
			},

			needFillReceiver(row) {
				return !!(row && row.is_decrypt == 0)
			},

			needMatchSource(row) {
				return !!(row && row.is_decrypt == 1 && row.match_shop_id == 0
					&& row.style_number && row.size)
			},

			onMatchSource(row) {
				if (this.matchSourceSubmitting || !row) {
					return
				}
				var styleNumberSize = this.formatStyleNumberSize(row)
				if (!styleNumberSize) {
					this.$message.warning('款号或尺码缺失，无法匹配')
					return
				}
				var orderSn = row.order_sn
				var params = new URLSearchParams()
				params.append('order_sn', orderSn)
				params.append('style_number_size', styleNumberSize)
				this.matchSourceSubmitting = true
				this.$axios.post('api/order/out_update_stylenumber', params).then(function(res) {
					if (res.data.code != 0) {
						this.$message.error(res.data.message || res.data.msg || '匹配失败')
						this.matchSourceSubmitting = false
						return
					}
					return this.onlist().then(function() {
						var matched = null
						var list = this.list || []
						for (var i = 0; i < list.length; i++) {
							if (list[i] && list[i].order_sn == orderSn) {
								matched = list[i]
								break
							}
						}
						if (matched && matched.match_shop_id > 0) {
							this.$message.success('渠道匹配完成')
						} else {
							this.$message.warning('未找到匹配渠道，请前往「匹配渠道」手动选择')
						}
						this.matchSourceSubmitting = false
					}.bind(this))
				}.bind(this)).catch(function(err) {
					console.log(err)
					this.$message.error('网络错误')
					this.matchSourceSubmitting = false
				}.bind(this))
			},

			buildFillReceiverAreaData(row) {
				var areaData = []
				if (!row) {
					return areaData
				}
				var province = row.province || ''
				var city = row.city || ''
				var area = row.town || row.area || ''
				if (province && city && area) {
					areaData.push(province, city, area)
				}
				return areaData
			},

			onFillReceiver(row) {
				if (!row) {
					return
				}
				this.fillReceiverForm = {
					pdd_order_id: row.id,
					order_sn: row.order_sn || '',
					receiver_name: row.receiver_name || '',
					receiver_phone: row.receiver_phone || '',
					receiver_address: row.receiver_address || '',
					areaData: this.buildFillReceiverAreaData(row),
				}
				this.showFillReceiver = true
				this.$nextTick(function() {
					if (this.$refs.fillReceiverForm) {
						this.$refs.fillReceiverForm.clearValidate()
					}
				}.bind(this))
			},

			onCloseFillReceiver() {
				if (this.fillReceiverSubmitting) {
					return
				}
				this.showFillReceiver = false
				this.fillReceiverForm = {
					pdd_order_id: '',
					order_sn: '',
					receiver_name: '',
					receiver_phone: '',
					receiver_address: '',
					areaData: [],
				}
			},

			onSubmitFillReceiver() {
				if (this.fillReceiverSubmitting) {
					return
				}
				this.$refs.fillReceiverForm.validate(function(valid) {
					if (!valid) {
						return
					}
					var areaData = this.fillReceiverForm.areaData || []
					var params = new URLSearchParams()
					params.append('pdd_order_id', this.fillReceiverForm.pdd_order_id)
					params.append('receiver_name', this.fillReceiverForm.receiver_name)
					params.append('receiver_phone', this.fillReceiverForm.receiver_phone)
					params.append('receiver_address', this.fillReceiverForm.receiver_address)
					params.append('receiver_province', areaData[0] || '')
					params.append('receiver_city', areaData[1] || '')
					params.append('receiver_area', areaData[2] || '')
					this.fillReceiverSubmitting = true
					this.$axios.post('api/order/out_fill_receiver', params).then(function(res) {
						if (res.data.code == 0) {
							this.$message.success('收件人信息已补填，可以下单了')
							this.fillReceiverSubmitting = false
							this.onCloseFillReceiver()
							this.onlist()
						} else {
							this.$message.error(res.data.message || res.data.msg || '补填失败')
							this.fillReceiverSubmitting = false
						}
					}.bind(this)).catch(function(err) {
						console.log(err)
						this.fillReceiverSubmitting = false
					}.bind(this))
				}.bind(this))
			},

			formatStyleNumberSize(row) {
				if (!row) {
					return ''
				}
				var styleNumber = row.style_number
				var size = row.size
				var hasStyle = styleNumber != null && styleNumber !== ''
				var hasSize = size != null && size !== ''
				if (hasStyle && hasSize) {
					return styleNumber + '|' + size
				}
				if (hasStyle) {
					return String(styleNumber)
				}
				if (hasSize) {
					return String(size)
				}
				return ''
			},

			formatDisplayValue(value) {
				return value != null && value !== '' ? value : '-'
			},

			formatOrderQuantity(row) {
				if (!row) {
					return '-'
				}
				// 独立数量字段（若后端后续补齐）
				var quantity = row.num != null && row.num !== ''
					? row.num
					: (row.goods_num != null && row.goods_num !== ''
						? row.goods_num
						: (row.goods_number != null && row.goods_number !== ''
							? row.goods_number
							: (row.goods_count != null && row.goods_count !== ''
								? row.goods_count
								: row.quantity)))
				if (quantity != null && quantity !== '') {
					return quantity
				}
				// out_list 当前把「数量|渠道价」拼在 good 里，如 xxx(1|199.00)
				var good = row.good != null ? String(row.good) : ''
				var matched = good.match(/\((\d+(?:\.\d+)?)\|/)
				return matched ? matched[1] : '-'
			},

			onclose3() {
				this.ruleForm1 = {
					order_sn: "",
					style_number_size: ""
				};
				this.show3 = false;
			},
			onsubkh() {
				this.$refs['ruleForm1'].validate((valid) => {
					if (valid) {
						var obj = JSON.parse(JSON.stringify(this.ruleForm1));
						this.$axios.post('api/user/pdd_update_stylenumber', obj).then(res => {
							if (res.data.code == 0) {
								this.$message.success('操作成功');
								this.onclose3();
								this.onlist();
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					}
				})
			},

			onsubxz() {
				this.$refs['ruleForm2'].validate((valid) => {
					if (valid) {
						var data = {
							retail_shop_id: this.ruleForm2.shop_id,
						}
						if (this.ruleForm2.btime) {
							data.btime = this.ruleForm2.btime
						}
						if (this.ruleForm2.etime) {
							data.etime = this.ruleForm2.etime
						}
						this.$axios.post('api/order/out_download_order', data).then(res => {
							if (res.data.code == 0) {
								this.$message.success('操作成功');
								this.onclose4();
								this.onlist();
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					}
				})
			},

			onptxd() {
				var ids = this.onids(this.alldata)
				if (!ids.length) {
					this.$message.warning('必须选择一条数据')
					return
				}
				this.$axios.post('api/order/out_to_platform', {
					ids: ids,
				}).then(res => {
					if (res.data.code == 0) {
						this.$message.success('操作成功')
						this.onlist()
					} else {
						this.$message.error(res.data.message)
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onSyncToShop() {
				if (!this.alldata || !this.alldata.length) {
					this.$message.warning('必须选择一条数据')
					return
				}
				// 不过滤同步状态，直接批量提交；后端会跳过无快递单号的订单并返回结果
				var orderSns = this.alldata.map(function(row) {
					return row.order_sn
				}).filter(function(sn) {
					return sn != null && sn !== ''
				}).join(',')
				if (!orderSns) {
					this.$message.warning('所选订单缺少订单号')
					return
				}
				this.$axios.post('api/user/pdd_retry_delivery_sync', {
					order_sn: orderSns,
				}).then(res => {
					var tip = res.data.msg || res.data.message
					if (res.data.code == 0) {
						this.$message.success(tip || '操作成功')
						this.onlist()
					} else {
						this.$message.error(tip || '同步失败')
					}
				}).catch(err => {
					console.log(err)
					this.$message.error('请求失败')
				})
			},

			onids(arrs) {
				if (!Array.isArray(arrs)) {
					return []
				}
				return arrs.map(function(row) {
					return row.id
				}).filter(function(id) {
					return id != null && id !== ''
				})
			},

			handleSelectChange(curRow) {
				console.log('单选', curRow);
				this.tableRadio = curRow;
			},
			
			onsubxg() {
				if(this.tableRadio) {
					var obj = {
						order_sn: this.tableRadio.order_sn,
						shop_id: this.tableRadio.shop_id,
						delivery_id: this.tableRadio.checked,
						prev_send_delivery_time: this.tableRadio.prev_send_delivery_time,
						agent_price: this.tableRadio.agent_price,
						security: this.tableRadio.security,
						delivery_price: this.onprice(this.tableRadio)
					};
					
					this.$axios.post('/api/user/pdd_update_match', obj).then(res => {
						if (res.data.code == 0) {
							this.$message.success('操作成功');
							this.onclose1();
							this.onlist();
						} else {
							this.$message.error(res.data.message);
						}
					}).catch(err => {
						console.log(err)
					})
					
					console.log(obj);
				}else {
					this.$message.warning('必须选择一条数据');
				}
			},
			
			onprice(obj) {
				var val = "";
				obj.delivery_config.forEach((v,k)=>{
					if(v.delivery_id == obj.checked) {
						val = v.delivery_price;
					}
				})
				
				return val;
			},

			onsecurity(n) {
				if (n == 1) {
					return ''
				}

				if (n == 2) {
					return '撕防伪'
				}

				if (n == 3) {
					return '不撕防伪'
				}
			},

			formatMatchStatusText(row) {
				var text = row && row.match_status_str ? String(row.match_status_str) : ''
				return text.trim().replace(/[^\u4e00-\u9fa5a-zA-Z0-9]+$/g, '')
			},

			// 与上方「平台订单状态」筛选一致：字段 platform_order_status，字典 appdata.list.order_status
			formatPlatformOrderStatus(row) {
				if (!row) {
					return ''
				}
				var statusId = row.platform_order_status
				var list = this.appdata && this.appdata.list && this.appdata.list.order_status
				if (statusId !== '' && statusId != null && list && list.length) {
					for (var i = 0; i < list.length; i++) {
						if (list[i].id == statusId) {
							return list[i].name
						}
					}
				}
				if (row.platform_order_status_str) {
					return row.platform_order_status_str
				}
				return statusId !== '' && statusId != null ? String(statusId) : ''
			},

			// 0未付款 1已付款 2已取消 3配货中 4已发货 5退货中 6已退货 7已作废 8已拒退 9已删除 10已成交 11无货
			platformOrderStatusTagType(row) {
				var statusId = row && row.platform_order_status
				if (statusId === '' || statusId == null) {
					var text = this.formatPlatformOrderStatus(row)
					if (!text) {
						return 'info'
					}
					if (/取消|退货|作废|无货|删除/.test(text)) {
						return 'danger'
					}
					if (/发货|成交/.test(text)) {
						return 'success'
					}
					if (/付款|配货|拒退|未付/.test(text)) {
						return 'warning'
					}
					return 'info'
				}
				var id = Number(statusId)
				if (id === 4 || id === 10) {
					return 'success'
				}
				if (id === 0 || id === 1 || id === 3 || id === 8) {
					return 'warning'
				}
				if (id === 2 || id === 5 || id === 6 || id === 7 || id === 9 || id === 11) {
					return 'danger'
				}
				return 'info'
			},

			matchStatusTagType(row) {
				var text = this.formatMatchStatusText(row)
				if (!text || text === '-') {
					return 'info'
				}
				if (text.indexOf('失败') !== -1) {
					return 'danger'
				}
				if (text.indexOf('已下单') !== -1 || text.indexOf('成功') !== -1) {
					return 'success'
				}
				if (text.indexOf('未下单') !== -1 || text.indexOf('可下单') !== -1) {
					return 'warning'
				}
				return 'info'
			},

			// 兼容字符串枚举 failed/success 与数字 0未同步 1成功 2失败
			isDeliverySyncFailed(row) {
				if (!row) {
					return false
				}
				var status = row.delivery_sync_status
				return status === 'failed' || status == 2
			},

			formatDeliverySyncStatus(row) {
				if (!row) {
					return ''
				}
				var status = row.delivery_sync_status
				if (status === 'failed' || status == 2) {
					return row.delivery_sync_error ? String(row.delivery_sync_error) : '同步失败'
				}
				if (status === 'success' || status == 1) {
					return '同步成功'
				}
				if (status === 'pending' || status == 0) {
					return '未同步'
				}
				if (status === '' || status == null) {
					if (row.delivery_sync_status_str) {
						return String(row.delivery_sync_status_str)
					}
					return ''
				}
				if (row.delivery_sync_status_str) {
					return String(row.delivery_sync_status_str)
				}
				return '未同步'
			},

			formatDeliverySyncTime(row) {
				if (!row || !this.isDeliverySyncFailed(row) || !row.delivery_sync_time) {
					return ''
				}
				return String(row.delivery_sync_time)
			},

			deliverySyncStatusTagType(row) {
				var status = row && row.delivery_sync_status
				if (status === 'success' || status == 1) {
					return 'success'
				}
				if (status === 'failed' || status == 2) {
					return 'danger'
				}
				var text = this.formatDeliverySyncStatus(row)
				if (!text) {
					return 'info'
				}
				if (text.indexOf('失败') !== -1) {
					return 'danger'
				}
				if (text.indexOf('成功') !== -1) {
					return 'success'
				}
				return 'info'
			},
		}
	}
</script>

<style scoped lang="less">
	.order {
		height: 100%;
		padding: 10px 10px 0 0;
		background-color: #fff;
		box-sizing: border-box;
	}

	.tablebox {
		height: calc(100% - 104px);
	}

	.tablediv {
		overflow: hidden;

		/deep/ .el-table__fixed,
		/deep/ .el-table__fixed-right {
			height: 100% !important;
		}
	}

	.h4 {
		font-size: 16px;
		font-weight: bold;
		margin-bottom: 10px;
	}

	.table-title {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 12px 16px;
	}

	.goods-order-meta {
		display: inline-flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 10px;
	}

	.goods-meta-tag {
		display: inline-flex;
		align-items: center;
		gap: 8px;
		padding: 4px 12px 4px 10px;
		border-radius: 999px;
		border: 1px solid transparent;
		line-height: 20px;
		box-sizing: border-box;

		em {
			font-style: normal;
			font-size: 12px;
			font-weight: 500;
			opacity: 0.88;
		}

		strong {
			font-size: 14px;
			font-weight: 600;
		}
	}

	.goods-meta-tag--style {
		color: #2563eb;
		background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
		border-color: #bfdbfe;

		em {
			color: #1d4ed8;
		}
	}

	.goods-meta-tag--size {
		color: #7c3aed;
		background: linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%);
		border-color: #ddd6fe;

		em {
			color: #6d28d9;
		}
	}

	.goods-meta-tag--qty {
		color: #ff4714;
		background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%);
		border-color: #fdba74;

		em {
			color: #ea580c;
		}
	}

	.block {
		display: flex;
		margin-bottom: 8px;

		div {
			margin-right: 20px;
		}
	}

	.info {
		margin-bottom: 20px;
	}

	.delivery-price-cell {
		display: inline-block;
		min-width: 36px;
		padding: 2px 8px;
		line-height: 22px;
		border-radius: 2px;
		cursor: pointer;
		box-sizing: border-box;
		user-select: none;
	}

	.delivery-price-cell--active {
		color: #fff;
		background: #409eff;
	}

	.delivery-price-empty {
		color: #c0c4cc;
	}

	/deep/ .item .el-select {
		width: 300px;
	}

	/deep/ .item .el-date-editor {
		width: 300px;
	}

	/deep/ .fill-receiver-cascader {
		width: 100%;
	}

	/deep/ .fill-receiver-cascader .el-input {
		width: 100%;
	}
	
	/deep/ .myradio .el-radio__label {
		display: none;
	}

	/deep/ td.match-status-column .cell {
		overflow: visible !important;
		text-overflow: clip !important;
	}

	.match-status-cell {
		display: inline-block;
		max-width: 100%;
		line-height: 24px;
		vertical-align: middle;
	}

	.match-status-tag {
		display: inline-block;
		padding: 0 8px;
		height: 24px;
		line-height: 22px;
		font-size: 13px;
		border-radius: 4px;
		border: 1px solid transparent;
		box-sizing: border-box;
		white-space: nowrap;
		vertical-align: middle;
	}

	.match-status-tag::before,
	.match-status-tag::after {
		content: none;
		display: none;
	}

	.match-status-tag--danger {
		color: #f56c6c;
		background: #fef0f0;
		border-color: #fbc4c4;
	}

	.match-status-tag--success {
		color: #67c23a;
		background: #f0f9eb;
		border-color: #c2e7b0;
	}

	.match-status-tag--warning {
		color: #e6a23c;
		background: #fdf6ec;
		border-color: #f5dab1;
	}

	.match-status-tag--info {
		color: #909399;
		background: #f4f4f5;
		border-color: #d3d4d6;
	}

	.match-status-empty {
		color: #909399;
		font-size: 13px;
	}

	.tracking-sync-cell {
		line-height: 20px;
	}

	.tracking-sync-number {
		margin-bottom: 4px;
		word-break: break-all;
	}

	.order-sn-pretime-cell {
		line-height: 1.35;
		text-align: center;
	}

	.order-sn-line,
	.pretime-line {
		white-space: nowrap;
	}

	.pretime-line {
		color: #606266;
		font-size: 12px;
	}

	.auto-cancel-tip {
		color: red;
		font-size: 12px;
	}

	/deep/ th.order-sn-pretime-column .cell {
		white-space: nowrap;
		padding-left: 10px;
		padding-right: 10px;
	}

	/deep/ td.order-sn-pretime-column .cell {
		white-space: normal;
		padding-left: 10px;
		padding-right: 10px;
	}

	.adapt-content-text {
		line-height: 1.35;
		white-space: nowrap;
	}

	.goods-security-cell,
	.channel-trade-cell {
		line-height: 1.35;
		text-align: center;
	}

	.goods-line,
	.security-line,
	.channel-line,
	.trade-no-line {
		white-space: nowrap;
	}

	.security-line,
	.trade-no-line {
		color: #606266;
		font-size: 12px;
	}

	/deep/ th.goods-security-column .cell,
	/deep/ th.channel-trade-column .cell {
		white-space: nowrap;
		padding-left: 10px;
		padding-right: 10px;
	}

	/deep/ td.goods-security-column .cell,
	/deep/ td.channel-trade-column .cell {
		white-space: normal;
		padding-left: 10px;
		padding-right: 10px;
	}

	.status-text-4 {
		width: 4em;
		margin: 0 auto;
		line-height: 1.35;
		word-break: break-all;
		white-space: normal;
	}

	/deep/ th.refund-status-column .cell,
	/deep/ td.refund-status-column .cell {
		white-space: normal;
		padding-left: 4px;
		padding-right: 4px;
	}

	.delivery-sync-error-text {
		color: #f56c6c;
		font-size: 12px;
		line-height: 1.35;
		text-align: left;
		word-break: break-all;
	}

	.tracking-sync-time {
		margin-top: 2px;
		color: #909399;
		font-size: 12px;
		line-height: 1.25;
		text-align: left;
	}

	.fill-receiver-tip {
		margin: 0 0 0 100px;
		color: #909399;
		font-size: 13px;
		line-height: 1.5;
	}

	.operation_i .op-fill-receiver {
		color: #e6a23c !important;
		font-weight: 600;
	}

	.operation_i .op-match-source {
		color: #409eff !important;
		font-weight: 600;
	}

	.return-address-cell {
		height: 48px;
		line-height: 24px;
		overflow: hidden;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		word-break: break-all;
		text-align: left;
		cursor: pointer;
	}

	.return-address-empty {
		color: #909399;
		font-size: 13px;
	}

	/deep/ td.return-address-column .cell {
		white-space: normal;
	}
</style>

<style lang="less">
.return-address-popover__content {
	max-height: 200px;
	overflow-y: auto;
	word-break: break-all;
	line-height: 1.5;
	margin-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/pdd/order.vue